export default __webpack_public_path__ + "static/media/logo-dark.31c2f12f.svg";